import React from "react"
import PropTypes from "prop-types"
import { Cell } from "fixed-data-table-2"
import { centsToCurrencyStr } from "shared/pac/helperFunctions"

/**
 * Cell component to render amounts as a currency string
 *
 * TODO support other currencies
*/
export const CurrencyCell = props => (
    <Cell {...props}>
        {props.cellValue ? centsToCurrencyStr(parseInt(props.cellValue)) : ""}
    </Cell>
)

CurrencyCell.propTypes = {
    /** Amount, in cents, to display */
    cellValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]), // Robust against either a Number or a String.
}

export default CurrencyCell
